export default __webpack_public_path__ + "static/Flare-77cc95cda611abad5a8b85d14d0c8dcd.png";